export default "__VITE_ASSET__KsSH$Q1d__";